import type { Components, Theme } from '@mui/material';

import { colors } from '../tokens';

export const MuiCheckbox: Components<Theme>['MuiCheckbox'] = {
  defaultProps: {
    disableRipple: true,
  },
  styleOverrides: {
    root: ({ theme }) => ({
      overflow: 'visible',
      '& .MuiSvgIcon-root': {
        clipPath: `inset(${theme.spacing(0.25)} round ${theme.spacing(0.5)})`,
        borderRadius: theme.spacing(0.5),
      },
      '&:not(.Mui-checked):not(.MuiCheckbox-indeterminate) .MuiSvgIcon-root': {
        color: colors.gray[200],
      },
      '&.Mui-checked .MuiSvgIcon-root, &.MuiCheckbox-indeterminate .MuiSvgIcon-root': {
        color: theme.palette.primary.main,
      },
      '&.Mui-focusVisible::after': {
        content: '""',
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 24,
        height: 24,
        borderRadius: 7,
        border: `2px solid ${theme.palette.primary.main}`,
        pointerEvents: 'none',
      },

      '&.Mui-disabled:not(.Mui-checked):not(.MuiCheckbox-indeterminate) .MuiSvgIcon-root':
        {
          color: colors.gray[300],
        },
      '&.Mui-disabled.Mui-checked .MuiSvgIcon-root, &.Mui-disabled.MuiCheckbox-indeterminate .MuiSvgIcon-root':
        {
          color: colors.green[700],
        },
    }),
  },
};
